import React from "react"
import { HistoricoCaixaContextProvider } from "./context/HistoricoCaixaContextProvider"
import { HistoricoCaixa } from "./HistoricoCaixa"

export function Index() {
    return (
        <HistoricoCaixaContextProvider>
            <HistoricoCaixa />
        </HistoricoCaixaContextProvider>
    )
}
